import {
  ContainerFileDropDialog,
  type ContainerFileDropChoice,
} from "@/action-dialog/dialogs/ContainerFileDropDialog";
import { createCallable } from "react-call";

const UNMOUNTING_DELAY_MS = 200;

export type ContainerFileDropCallableProps = {
  count: number;
  fileName?: string;
  destination: "canvas" | "chat";
};

/** Resolves with the chosen path, or null when dismissed. */
export const ContainerFileDropCallable = createCallable<
  ContainerFileDropCallableProps,
  ContainerFileDropChoice | null
>(
  ({ call, count, fileName, destination }) => (
    <ContainerFileDropDialog
      count={count}
      fileName={fileName}
      destination={destination}
      onChoose={(choice) => call.end(choice)}
      onClose={() => call.end(null)}
    />
  ),
  UNMOUNTING_DELAY_MS,
);

ContainerFileDropCallable.displayName = "ContainerFileDropCallable";
